import getAvailableRetentionPolicyTagsOperation from 'owa-service/lib/operation/getAvailableRetentionPolicyTagsOperation';
import GetRetentionPolicyTagsResponse from 'owa-service/lib/contract/GetRetentionPolicyTagsResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Service to get list of available policies
 */
export default function getAvailablePolicies(): Promise<GetRetentionPolicyTagsResponse> {
    return getAvailableRetentionPolicyTagsOperation({
        Header: getJsonRequestHeader(),
    });
}
